module.exports = __webpack_public_path__ + "static/media/skyCinema.22f5f4e1.jpg";